
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://ctljbqqsftgnrwxlskbd.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN0bGpicXFzZnRnbnJ3eGxza2JkIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTY4NjM1NTksImV4cCI6MjAxMjQzOTU1OX0.pyUNqDbmeKRT3qg7ttm7ZM0mv7AQKQR-7FL3uFxy5ok"
const supabaseClient = createClient(supabaseUrl, supabaseAnonKey,{auth:{autoRefreshToken:false,}})

export  {
  supabaseClient,
}